module.exports = __webpack_public_path__ + "static/media/SilcaLogo.2eb8be25.png";